import { EBuildingClassType } from '../../../../json_query';
import { changeBuildingClass } from '../../../state/advanced/building_class';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const BuildingClass = getMultiSelectParam<EBuildingClassType>(
  'Класс',
  [
    { title: 'A+', value: EBuildingClassType.APlus },
    { title: 'A', value: EBuildingClassType.A },
    { title: 'B+', value: EBuildingClassType.BPlus },
    { title: 'B', value: EBuildingClassType.B },
    { title: 'B-', value: EBuildingClassType.BMinus },
    { title: 'C', value: EBuildingClassType.C },
  ],
  'building_class_type',
  changeBuildingClass,
);
